module.exports = __webpack_public_path__ + "howBanner.png?14af838d42a5f893ab45c0ad6902deef";


//////////////////
// WEBPACK FOOTER
// ./src/assets/howBanner.png
// module id = 18
// module chunks = 0